import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import MosIcon from '@mos-front-components/public/es/components/MosIcon';
import MosSelect from '@mos-front-components/public/es/components/MosSelect';
import useMedia from 'use-media';
import { useOuterClick } from 'react-outer-click';

import Tooltip, { POSITION, THEME } from '@mos-cat/tooltip';

import {
  giaSelectedPropTypes,
  giaSelectedDefaultProp,
  giaBlurPropTypes
} from '../../propTypes/giaPropTypes';

import TextField from '@mos-cat/text-field';

const GiaCodeSelector = ({
  changeGiaItem,
  blurGiaItem,
  giaSelected,
  blur,
  hasError,
  registrationCodes,
  saveDraft
}) => {
  const [openCodeTooltip, setOpenCodeTooltip] = useState(false);
  const [openNumberTooltip, setOpenNumberTooltip] = useState(false);

  const codeTooltipRef = useRef(null);
  const numberTooltipRef = useRef(null);

  const cellGiaClassNames =
    registrationCodes < 1
      ? 'StepGia__CellGIA StepGia__CellGIA__ButtonHidden'
      : 'StepGia__CellGIA';

  useOuterClick(codeTooltipRef, () => {
    if (openCodeTooltip) {
      setOpenCodeTooltip(!openCodeTooltip);
    } else {
      setOpenCodeTooltip(openCodeTooltip);
    }
  });

  useOuterClick(numberTooltipRef, () => {
    if (openNumberTooltip) {
      setOpenNumberTooltip(!openNumberTooltip);
    } else {
      setOpenNumberTooltip(openNumberTooltip);
    }
  });

  const isPhone = useMedia({ maxWidth: 870 });

  const handleChange = () => null;

  const handleBlur = field => {
    blurGiaItem(field);
    saveDraft();
  };

  const handleInputChangeRegistrationCode = value => {
    changeGiaItem({ value, field: 'registration_code' });
  };

  const handleInputChangeDocumentNumber = ev => {
    changeGiaItem({ value: ev.currentTarget.value, field: 'document_number' });
  };

  const isDocumentNumberFieldPristine =
    typeof giaSelected.document_number.invalidMessage === 'string';

  const codeClassName = openCodeTooltip ? 'TooltipClose' : 'TooltipQuestion';
  const numberClassName = openNumberTooltip
    ? 'TooltipClose'
    : 'TooltipQuestion';

  return (
    <div className="StepGia__RowGIA">
      <div className={cellGiaClassNames}>
        <div ref={codeTooltipRef}>
          <Tooltip
            theme={THEME.INFO}
            open={openCodeTooltip}
            floating
            position={POSITION.top}
            content={
              <div className="StepGia__Info">
                Код регистрации, указанный в вашем уведомлении на экзамен.
                <br />
                Пример: 1111-2222-3333
              </div>
            }
          >
            <MosIcon
              name={codeClassName}
              className="StepGia__Icon"
              onClick={() => setOpenCodeTooltip(!openCodeTooltip)}
            />
          </Tooltip>
        </div>
        <MosSelect
          placeholder="Код регистрации"
          value={giaSelected.registration_code.value}
          suggestions={registrationCodes}
          onInputChange={handleInputChangeRegistrationCode}
          onChange={handleChange}
          onBlur={() => handleBlur('registration_code')}
          hasError={
            hasError ||
            (giaSelected.registration_code.message && blur.registration_code)
          }
          maskOptions={{
            mask: '9999-9999-9999'
          }}
        />
      </div>
      <div className="StepGia__CellGIA">
        <div ref={numberTooltipRef}>
          <Tooltip
            theme={THEME.INFO}
            open={openNumberTooltip}
            floating
            wrapperClassName="StepGia__Tooltip"
            position={isPhone ? POSITION.bottom : POSITION.top}
            content={
              <div className="StepGia__Info">
                Номер документа, удостоверяющего личность (без серии), или номер
                актовой записи о рождении, который был указан при регистрации на
                экзамен, без указания каких-либо специальных символов.
                <br />
                Пример: 777111 или 777asd
              </div>
            }
          >
            <MosIcon
              name={numberClassName}
              className="StepGia__Icon"
              onClick={() => setOpenNumberTooltip(!openNumberTooltip)}
            />
          </Tooltip>
        </div>
        <TextField
          label={
            !isDocumentNumberFieldPristine &&
            blur.document_number &&
            !giaSelected.document_number.valid &&
            giaSelected.document_number.message
              ? giaSelected.document_number.message
              : 'Номер документа (без серии)'
          }
          className="PguFormGrid__field"
          value={giaSelected.document_number.value}
          error={
            hasError ||
            (giaSelected.document_number.message && blur.document_number)
          }
          onChange={handleInputChangeDocumentNumber}
          onBlur={() => handleBlur('document_number')}
        />
      </div>
    </div>
  );
};

GiaCodeSelector.defaultProps = {
  giaSelected: giaSelectedDefaultProp,
  hasError: false,
  registrationCodes: [],
  documentNumbers: []
};

GiaCodeSelector.propTypes = {
  giaSelected: giaSelectedPropTypes,
  blur: giaBlurPropTypes,
  hasError: PropTypes.bool,
  changeGiaItem: PropTypes.func.isRequired,
  blurGiaItem: PropTypes.func.isRequired,
  registrationCodes: PropTypes.arrayOf(PropTypes.string),
  documentNumbers: PropTypes.arrayOf(PropTypes.string)
};

export default GiaCodeSelector;
